import React from "react";
import { useNavigate } from "react-router-dom";
import { FaMicrophone } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { useSmartDownload } from "../../hooks/useSmartDownload";
import { SCROLL_OFFSET } from "./sections";

/*
  Same closing panel as the Google Docs article: the near-opaque dark linear
  gradient is painted last so the #407BFF radial still reads from the top
  centre as designed.
*/
const PANEL_BACKGROUND = [
  "radial-gradient(60% 90% at 50% 0%, #407BFF 0%, rgba(46, 111, 243, 0) 100%)",
  "radial-gradient(70.71% 70.71% at 50% 50%, rgba(255, 255, 255, 0.07) 0.09%, rgba(0, 0, 0, 0) 0.09%)",
  "linear-gradient(180deg, rgba(18, 22, 34, 0.96) 0%, #0A0D16 100%)",
].join(", ");

const StartVoicePromptingSection = () => {
  const navigate = useNavigate();
  const smartDownload = useSmartDownload();

  return (
    <section
      id="start-voice-prompting"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full bg-white font-inter"
    >
      <div className="mx-auto max-w-[1240px] px-6 py-16 sm:px-8 md:px-[32px] md:py-[96px]">
        <div
          style={{ background: PANEL_BACKGROUND }}
          className="flex flex-col items-center justify-center overflow-hidden rounded-[28px] px-6 py-14 text-center sm:px-10 sm:py-20 md:min-h-[420px] md:px-16"
        >
          {/* Eyebrow pill */}
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-[7px] font-jakarta text-[11px] font-semibold uppercase leading-[13px] tracking-[0.12em] text-white/90 backdrop-blur-sm">
            <FiDownload className="h-[12px] w-[12px] shrink-0" />
            Get Started Free
          </span>

          <h2 className="mt-[36px] max-w-[600px] font-jakarta text-[30px] font-bold leading-[1.2] tracking-[-0.8px] text-white sm:text-[38px] md:text-[48px]">
            Start Using Voice Prompting AI Today

          </h2>

          <p className="mt-[20px] max-w-[580px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-white/60">
            Try Zero Typing AI free and dictate prompts directly into ChatGPT,
            Claude, Gemini, and more.
          </p>

          {/* Action buttons */}
          <div className="mt-[32px] flex flex-wrap items-center justify-center gap-4">
            <button
              type="button"
              onClick={() => navigate("/demo")}
              className="flex cursor-pointer items-center gap-3 rounded-full bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] px-6 py-3.5 text-[15px] font-semibold text-white shadow-[0_4px_18px_rgba(58,177,246,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:from-[#33A2E5] hover:to-[#386FE8] hover:shadow-xl sm:text-[16px]"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/20 text-white">
                <FaMicrophone className="h-4 w-4" />
              </span>
              <span>Try Zero Typing Free</span>
            </button>

            <button
              type="button"
              onClick={() => smartDownload("voice_prompting_ai_footer_cta")}
              className="flex cursor-pointer items-center gap-3 rounded-full border border-white/15 bg-white/10 px-6 py-3.5 text-[15px] font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-white/15 sm:text-[16px]"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/15 text-white">
                <FiDownload className="h-[18px] w-[18px]" />
              </span>
              <span>Download Zero Typing</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartVoicePromptingSection;
